import { useEffect, useRef, useState } from "react";

function Features() {
  const [show, setShow] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
        }
      },
      {
        threshold: 0.2,
      }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <>
      <style>{`
        .features-band{
          background:#17130f;
          color:#c7a97a;
          display:grid;
          grid-template-columns:repeat(4,1fr);
          padding: 30px 0;
          text-align:center;
          overflow:hidden;
          margin-top:0;
          width: 80%;
          margin: 0 auto;
        }

        .feature-item{
          padding:0 42px;
          border-right:1px solid rgba(199,169,122,.22);
          opacity:0;
          transform:translateY(70px);
          transition:
            opacity 1s ease,
            transform 1s cubic-bezier(.22,1,.36,1);
        }

        .feature-item.no-border{
          border-right:none;
        }

        .feature-item:hover{
          transform:translateY(-8px) scale(1.02) !important;
        }

        .feature-img{
          width:155px;
          height:155px;
          object-fit:contain;
          margin-bottom:18px;
        }

     

        .feature-item h4{
          margin:0 0 14px;
          font-size:14px;
          font-weight:100;
          color:#d8c4a1;
        }

        .feature-item p{
          margin:0 auto;
          max-width:230px;
          font-size:14px;
          color:#d8c4a1;
          font-weight:100;
        }

        @media(max-width:991px){
          .features-band{
            grid-template-columns:1fr 1fr;
            gap:0;
          }

          .feature-item{
            border-right:none;
            padding:0 20px;
          }
        }

        @media(max-width:640px){
          .features-band{
            grid-template-columns:repeat(1, 1fr) !important;
            padding:10px 22px;
            width:90%;
            margin-top: 50px;
          }
            .feature-img {
              width: 155px;
              height: 155px;
              object-fit: contain;
              margin-bottom: 0;
          }
              .time{
               height: 100px;
              }
        }
      `}</style>

      <section className="features-band" ref={sectionRef}>
        <div
          className="feature-item"
          style={{
            opacity: show ? 1 : 0,
            transform: show ? "translateY(0)" : "translateY(70px)",
            transitionDelay: "0.1s",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/feature11.png"}
            alt="Conscious"
            className="feature-img"
          />

          <h4>Conscious</h4>

          <p style={{ textTransform: "capitalize" }}>
            We choose ingredients and materials that honor your body and the
            earth.
          </p>
        </div>

        <div
          className="feature-item"
          style={{
            opacity: show ? 1 : 0,
            transform: show ? "translateY(0)" : "translateY(70px)",
            transitionDelay: "0.3s",
          }}
        >
          <img
           src={process.env.PUBLIC_URL + "/feature12.png"}
            alt="Ritualistic"
            className="feature-img"
          />

          <h4>Ritualistic</h4>

          <p style={{ textTransform: "capitalize" }}>
            We transform daily moments into sacred rituals that ground and
            elevate.
          </p>
        </div>

        <div
          className="feature-item"
          style={{
            opacity: show ? 1 : 0,
            transform: show ? "translateY(0)" : "translateY(70px)",
            transitionDelay: "0.5s",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/feature15.png"}
            alt="Timeless"
            className="feature-img time"
          
          />

          <h4>Timeless</h4>

          <p>
            Our creations are made to be cherished, worn and passed down.
          </p>
        </div>

        <div
          className="feature-item no-border"
          style={{
            opacity: show ? 1 : 0,
            transform: show ? "translateY(0)" : "translateY(70px)",
            transitionDelay: "0.7s",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/feature14.png"}
            alt="Soul-led"
            className="feature-img"
          />

          <h4>Soul-led</h4>

          <p>
            Every detail is guided by intuition, beauty and purpose.
          </p>
        </div>
      </section>
    </>
  );
}

export default Features;